import { combineReducers } from 'redux';
import permissions from './permissions';
import profile from './profile';
import attributes from './attributes';
import profileOptions from './profileOptions';
import emailAddresses from './emailAddresses';
import notifications from './notifications';
import hubUsers from './hubUsers';
import avatar from './avatar';
import portalSettings from './portalSettings';
export default combineReducers({
  permissions,
  profile,
  attributes,
  emailAddresses,
  profileOptions,
  notifications,
  hubUsers,
  avatar,
  portalSettings
});